import { LinearGradient } from 'expo-linear-gradient';
import withLink from 'hoc/withLink';
import { useBreakpointValueGS } from 'hooks/useBreakpointValueGS';
import { useMemo } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { calcHeightWithWidth, calcSizeForDevice } from 'utils/index';
import { Platform } from 'utils/platform';

import Button from 'components/Button';
import FastImage from 'components/FastImage';
import { Icons } from 'components/Icons';

const BoxedMidCard: React.FC<CardProps & { isSelected?: boolean; percentageWatched?: number }> = ({
  uri,
  title,
  description,
  onPress,
  duration,
  percentageWatched,
  lines,
  isSelected,
}) => {
  const midBoxedCardWidth = useBreakpointValueGS({
    base: Platform.isAndroidTV ? 112.5 : 150,
    lg: calcSizeForDevice(150, 225),
  });

  const midBoxedCardHeight = useMemo(
    () => calcHeightWithWidth(midBoxedCardWidth, 3 / 2),
    [midBoxedCardWidth]
  );

  return (
    <Button
      useTVFocus
      variant="invisible"
      role="link"
      onPress={onPress}
      style={{ flexDirection: 'row', flex: 1, height: undefined, gap: calcSizeForDevice(16) }}>
      {Boolean(uri) && (
        <FastImage
          source={{ uri }}
          style={{
            borderRadius: 5,
            overflow: 'hidden',
            position: 'relative',
            width: midBoxedCardWidth,
            height: midBoxedCardHeight,
          }}>
          <LinearGradient
            start={{ x: 0, y: 1 }}
            end={{ x: 0, y: 0 }}
            locations={[0.1, 0.95]}
            style={{ width: '100%', height: '100%', position: 'absolute', zIndex: 1 }}
            colors={['#000000', 'transparent']}>
            <View
              style={{
                flexDirection: 'row',
                position: 'absolute',
                bottom: calcSizeForDevice(18),
                right: calcSizeForDevice(5),
                backgroundColor: 'rgba(51, 51, 51, 0.6)',
                paddingHorizontal: calcSizeForDevice(6),
                borderRadius: 6,
                alignItems: 'center',
              }}>
              {Boolean(duration) && (
                <Text
                  style={[
                    styles.durationText,
                    {
                      marginRight: calcSizeForDevice(6),
                      fontSize: calcSizeForDevice(12, 14),
                    },
                  ]}>
                  {duration}
                </Text>
              )}
              <Icons.CirclePlay
                width={calcSizeForDevice(16).toString()}
                height={calcSizeForDevice(16).toString()}
              />
            </View>
            {Boolean(percentageWatched) && (
              <View
                style={[
                  styles.progressContainer,
                  { paddingHorizontal: calcSizeForDevice(8), marginTop: 'auto' },
                ]}>
                <View
                  style={[
                    styles.progressBar,
                    {
                      borderBottomLeftRadius: calcSizeForDevice(3),
                      borderBottomRightRadius: calcSizeForDevice(3),
                      height: calcSizeForDevice(4),
                      marginBottom: calcSizeForDevice(8),
                    },
                  ]}>
                  <View
                    style={[
                      styles.progress,
                      {
                        borderBottomLeftRadius: calcSizeForDevice(3),
                        width: `${percentageWatched || 0}%`, // width precisa ser string para porcentagem
                        height: calcSizeForDevice(4),
                      },
                    ]}
                  />
                </View>
              </View>
            )}
          </LinearGradient>
        </FastImage>
      )}
      <View
        style={[
          styles.textColumn,
          {
            flex: 3,
            marginLeft: calcSizeForDevice(5),
          },
        ]}>
        <View style={{ marginBottom: calcSizeForDevice(8) }}>
          {Boolean(title) && (
            <Text
              style={[
                styles.title,
                {
                  fontSize: calcSizeForDevice(14, 20),
                  lineHeight: calcSizeForDevice(20, 24),
                },
              ]}
              numberOfLines={lines?.title}>
              {title}
            </Text>
          )}
          {isSelected && Platform.isTV && (
            <View style={{ marginTop: calcSizeForDevice(5) }}>
              <Icons.Streaming
                width={calcSizeForDevice(32).toString()}
                height={calcSizeForDevice(32).toString()}
              />
            </View>
          )}
        </View>
        {Boolean(description) && (
          <Text
            style={[
              styles.description,
              {
                fontSize: calcSizeForDevice(12, 18),
                lineHeight: calcSizeForDevice(15, 24),
              },
            ]}
            numberOfLines={lines?.description}>
            {description}
          </Text>
        )}
      </View>
    </Button>
  );
};

const styles = StyleSheet.create({
  durationBox: {
    flexDirection: 'row',
    position: 'absolute',
    backgroundColor: '#33333399',
    alignItems: 'center',
  },
  durationText: {
    color: 'white',
    fontWeight: '700',
  },
  progressContainer: {
    width: '100%',
    // position: 'relative',
  },
  progressBar: {
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    overflow: 'hidden',
    width: '100%',
  },
  progress: {
    backgroundColor: 'rgba(255, 255, 255, 1)',
  },
  textColumn: {
    flexDirection: 'column',
  },
  title: {
    color: 'white',
    fontWeight: '600',
  },
  description: {
    color: '#7D7D7D',
  },
});

export default withLink(BoxedMidCard, 'BoxedMidCard');
